'use strict';

var _ = require('lodash');

var withoutJsonSuffix = function withoutJsonSuffix(pageJsonFileName) {
    return pageJsonFileName.replace('.json', '');
};

function getPageFileNames(pageList) {
    if (!pageList) {
        return {};
    }
    var accumulator = {
        masterPage: withoutJsonSuffix(pageList.masterPageJsonFileName)
    };
    var reducer = function reducer(result, page) {
        var _$assign;

        return _.assign(result, (_$assign = {}, _$assign[page.pageId] = withoutJsonSuffix(page.pageJsonFileName), _$assign));
    };
    return _(pageList.pages).filter('pageJsonFileName').reduce(reducer, accumulator);
}

module.exports = {
    getPageFileNames: getPageFileNames
};
//# sourceMappingURL=pageUtils.js.map